import { render, staticRenderFns } from "./controlesOP.vue?vue&type=template&id=483f98fa"
import script from "./controlesOP.vue?vue&type=script&lang=js"
export * from "./controlesOP.vue?vue&type=script&lang=js"
import style0 from "./controlesOP.vue?vue&type=style&index=0&id=483f98fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports